import { useTranslation } from "react-i18next";

export default function StudentsPage() {
  const { t } = useTranslation("sidebar");

  return <title>{`${t("students")} - Ximly`}</title>;
}
